import React from 'react';
import { connect } from 'react-redux';
import FontAwesome from 'react-fontawesome'
import moment from 'moment';
import numeral from 'numeral';
import Pagination from 'react-js-pagination';
import Box from '../Layout/Box';
import ButtonStrip from '../Layout/ButtonStrip';
import BoxButton from '../Layout/BoxButton';
import history from '../../utils/history';
import ModalSelectorFromList from '../Shared/ModalSelectorFromList';
import ModalFilter from './ModalFilter';
import SelectorInput from '../Shared/SelectorInput';
import store from '../../utils/store';
import { changeNumberRegisterToShow, downloadFile, getReporteRadicados, setOrderBy, showHideModalFilter, updateInputs } from '../../actions/reportes';
import { showModalSelector, selectFromSelector, getParameterByName } from '../../actions/common';
import { extractKeyValue } from '../../utils/helpers';

import Immutable from 'immutable'

export function findValues(c, x) {
    const enums = store.getState().common.get('enums').toJS()
    let value = x.getIn(c.value.split('.'))
    if (c.value === 'estado') {
        value = enums.solicitudes.estados[value]
    } else if (c.value === 'tipo') {
        value = enums.solicitudes.tipos[value].caption
    }
    return value
}

class Radicados extends React.Component {

    // constructor(props) {
    //     super(props);
    //     this.state = {
    //         page: 1
    //     };
    // }

    componentWillMount() {
        this.props.getParameterByName('ALMACEN')
    }

    handleOpenSelectorResponsableCompras = (list) => {

        let columns = [
            { id: 1, caption: 'Username', value: 'USUARIO', width: '30%' },
            { id: 2, caption: 'Nombres', value: 'NOMBRES', width: '45%' },
            { id: 3, caption: 'Almacén', value: 'ALMACEN', width: '25%' }
        ];

        const payload = {};

        const fn = (a) => {
            payload.path = list
            payload.value = a;
            this.props.selectFromSelector('MODIFICAR_INPUTS_REPORTES', payload);
        };

        this.props.showModalSelector('Listado de responsable del almacén', columns, `/solicitudes/bienes-investigacion/responsables-almacen`, fn);
    }

    newPageOfResults(pg) {
        this.props.search(pg);
    }


    downloadFile(type_report) {
        const url = '/reportes/download_radicados';
        const params = {
            // usuario_id: this.props.reportes.getIn(['storage_manage', 'USUARIO']),
            // usuario_nombre: this.props.reportes.getIn(['storage_manage', 'NOMBRES']),
            fecha_inicio: this.props.reportes.getIn(['radicados', 'initial_date']),
            fecha_fin: this.props.reportes.getIn(['radicados', 'final_date']),
            almacen: this.props.reportes.get('storage'),
            filters: this.props.reportes.getIn(['radicados', 'modalFilter', 'filters']).filter(column => column.get('apply')).toJS(),
            type_report
        };
        return this.props.downloadFile(url, params, type_report);
    }

    render() {

        const { reportes, enums, orderBy, showRecords, totalRecords, almacenes, page } = this.props;     

        const tableCols = [
            { id: 1, caption: 'Almacén', value: 'almacen', type: 'string', format: '', width: '6%', enums: extractKeyValue(almacenes, 'ALMACEN', 'ALMACEN') },
            { id: 2, caption: 'Responsable de compras', value: 'responsable_compras', type: 'string', format: '', width: '13%' },
            { id: 3, caption: 'Usuario almacén', value: 'usuario', type: 'string', format: '', width: '13%' },
            { id: 4, caption: 'No. Solicitud', value: 'solicitud_id', type: 'string', format: '', width: '7.5%' },
            { id: 5, caption: 'No. Orden/Contrato', value: 'orden_contrato', type: 'string', format: '', width: '10.5%' },
            { id: 6, caption: 'Radicado', value: 'n_radicado', type: 'string', format: '', width: '6%' },
            { id: 7, caption: 'Valor factura', value: 'valor_factura', type: 'number', format: '$ 0,0[.]00', width: '8%' },
            { id: 8, caption: 'Nombre proveedor', value: 'nombre_proveedor', type: 'string', format: '', width: '12%' },
            { id: 9, caption: 'NIT proveedor', value: 'nit_proveedor', type: 'number', width: '8%' },
            { id: 10, caption: 'Descripción del servicio', value: 'concepto', type: 'string', width: '13%' },
        ];
        const boxActions = [
            <BoxButton key="ba[0][0]" name="search" title="Buscar" onClick={e => this.newPageOfResults(1)} />,
            <BoxButton key="ba[0][1]" name="filter" onClick={ e => this.props.showHideModalFilter(true, tableCols) } title="Filtro"/>,
            <BoxButton key="ba[0][2]" name="file-excel-o" onClick={ e => this.downloadFile('xlsx') } title="Descargar excel"/>,
            <BoxButton key="ba[0][3]" name="file-pdf-o" onClick={ e => this.downloadFile('pdf') } title="Descargar PDF"/>,
        ];
        const pagination = <Pagination
            activePage={page}
            itemsCountPerPage={showRecords}
            totalItemsCount={totalRecords}
            pageRangeDisplayed={10}
            onChange={(pg) => this.newPageOfResults(pg)}
            firstPageText={<FontAwesome name="angle-double-left" />}
            prevPageText={<FontAwesome name="angle-left" />}
            nextPageText={<FontAwesome name="angle-right" />}
            lastPageText={<FontAwesome name="angle-double-right" />}
        />


        const formRequest = <div className="row" style={{padding:'0px'}}>

            <div className="col-md-3">
                <div className="form-group">
                    <label className="control-label">Almacén</label>
                    <select className="form-control input-sm" value={reportes.get('storage') || 0} onChange={(e) => this.props.updateInputs('storage', e.target.value)}>
                        <option value={""}>Ninguno</option>
                        {
                            almacenes && almacenes.map((almacen, ialmacen) => {
                                return <option key={`opt[0][${ialmacen}]`} value={almacen.get('ALMACEN')}>{almacen.get('ALMACEN')}</option>
                            })
                        }
                    </select>
                </div>
            </div>

            {/* <div className="col-md-3 col-sm-4 col-xs-12">
                <div className="form-group">
                    <label className="control-label">Usuario</label>
                    <SelectorInput
                        value={reportes.get('storage_manage') ? reportes.getIn(['storage_manage', 'NOMBRES']) : ''}
                        onClick={() => this.handleOpenSelectorResponsableCompras('storage_manage')}
                        onReset={() => this.props.updateInputs('storage_manage', null)}
                    />
                </div>
            </div> */}

            <div className="col-md-2 col-sm-4 col-xs-12">
                <div className="form-group">
                    <label htmlFor="initial_date" className="control-label">Fecha Inicial</label>
                    <input type="date" className="form-control input-sm" name="initial_date"
                        value={reportes.getIn(['radicados', 'initial_date'])}
                        onChange={(e) => this.props.updateInputs("radicados.initial_date", e.target.value)} />
                </div>
            </div>

            <div className="col-md-2 col-sm-4 col-xs-12">
                <div className="form-group">
                    <label htmlFor="final_date" className="control-label">Fecha Final</label>
                    <input type="date" className="form-control input-sm" name="final_date"
                        value={reportes.getIn(['radicados', 'final_date'])}
                        onChange={(e) => this.props.updateInputs("radicados.final_date", e.target.value)} />
                </div>
            </div>


        </div>



        return (
            <div className="row" style={{ height: '100%' }}>
                <div className="col-md-12 col-sm-12 col-xs-12" style={{ height: '100%' }}>

                    <Box title="Reporte de radicados" stretch>

                        <ButtonStrip actions={boxActions} totalRecords={totalRecords}
                            showRecords={showRecords} pagination={pagination}
                            changeRecordsToShow={(records) => this.props.changeNumberRecordsToShow(records)} 
                            formRequest = { formRequest }
                        />


                        <div className="box-content" style={{ flex: 1, height: 0, overflow: 'auto'}}>
                            <div style={{ display: 'flex', height: '100%', justifyContent: 'space-between', flexDirection: 'column' }}>

                                <table className="table table-condensed table-bordered table-striped table-sorted nowrap" id="table-evaluacion-proveedor">
                                    <thead>
                                        <tr>
                                            {
                                                tableCols.map(x => {
                                                    const style = { width: `${x.width}` }
                                                    return (
                                                        <th key={ `th1[${x.id}]` } style={ style } onClick={ e => this.props.setOrderBy(x) }
                                                            className={ (orderBy.get('field') === x.value) ? (orderBy.get('asc') ? 'asc' : 'desc') : '' }>
                                                            { x.caption }
                                                        </th>
                                                    )
                                                })
                                            }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            reportes.getIn(['radicados', 'data']).size > 0 ? reportes.getIn(['radicados', 'data']).map((x, index) => {
                                                return (
                                                    <tr key={`tr1[${x.get('proveedor_id')}${index}]`} className={x.get('selected') ? 'info' : ''}>
                                                        {
                                                            tableCols.map(c => {
                                                                let alignment = 'left'
                                                                let value = findValues(c, x)
                                                                if (c.type) {
                                                                    switch (c.type) {
                                                                        case 'datetime':
                                                                            value = value ? moment(value).format(c.format) : '';
                                                                            alignment = 'right';
                                                                            break
                                                                        case 'bool':
                                                                            if (typeof value === 'string') value = parseInt(value, 10)
                                                                            value = <div style={{ textAlign: 'center', fontSize: '1.1em' }}><i className={`fa fa-${value ? 'check-' : ''}square`} /></div>
                                                                            break
                                                                        case 'number':
                                                                            value = numeral(value).format(c.format)
                                                                            alignment = 'right'
                                                                            break
                                                                        default:
                                                                    }
                                                                }
                                                                const style = { textAlign: alignment }
                                                                if (c.id === 10 && value) {
                                                                    value = value.split(',').map((v, i) => <p key={`serv[${i+1}]`}style={{margin: '0'}}>{v}</p>)
                                                                }
                                                                if (c.LinkToEdit) {
                                                                    return (
                                                                        <td key={`td1[${x.get('id')}][${c.id}]`} className='LinkToEdit' style={style} onClick={e => history.push(window.FOLDER + `/solicitudes/${enums.solicitudes.tipos[x.get('tipo')].url}/${x.get('id')}`)}>{value}</td>
                                                                    )
                                                                } else {
                                                                    return (
                                                                        <td key={`td1[${x.get('id')}][${c.id}]`} style={style}>{value}</td>
                                                                    )
                                                                }
                                                            })
                                                        }
                                                    </tr>
                                                )
                                            }) : <tr><td colSpan={tableCols.length}>No existen registros</td></tr>
                                        }
                                    </tbody>
                                </table>
                                
                            </div>
                        </div>


                    </Box>
                </div>
                <ModalSelectorFromList />
                <ModalFilter />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { reportes } = state;
    return {
        reportes,
        orderBy: reportes.getIn(['radicados', 'orderBy']),
        enums: state.common.get('enums').toJS(),
        almacenes: state.common.getIn(['parametros', 'ALMACEN']),
        showRecords: reportes.getIn(['radicados', 'showRecords']),
        totalRecords: reportes.getIn(['radicados', 'totalRecords']),
        page: reportes.getIn(['radicados', 'page']),
    }
};



const mapDispatchToProps = (dispatch) => {
    return {
        //getProviders: (keyword, cb) => dispatch(getProviders(keyword, cb))
        showModalSelector: (title, fields, url, action) => dispatch(showModalSelector(title, fields, url, action)),
        showHideModalFilter: (state, tableCols) => dispatch(showHideModalFilter(state, tableCols, 'radicados')),
        setOrderBy: (field) => dispatch(setOrderBy(field, 'radicados')),
        selectFromSelector: (type, payload) => dispatch(selectFromSelector(type, payload)),
        changeNumberRecordsToShow: (number) => dispatch(changeNumberRegisterToShow(number, 'radicados')),
        search: (page = 1) => dispatch(getReporteRadicados(page)),
        downloadFile: (url, params, type) => dispatch(downloadFile(url, params, `Radicados.${type}`)),
        getParameterByName: (nombre) => dispatch(getParameterByName(nombre)),
        updateInputs: (path, value) => dispatch(updateInputs(path, value)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Radicados);


// WEBPACK FOOTER //
// ./src/components/Reportes/Radicados.jsx